import { BillingModel } from "../../billing/models/BillingModel";
import { ProductModel } from "../../product/models/ProductModel";
import { SellerModel } from "../../seller/models/SellerModel";
import { SubscriberProductAgreementModel } from "./SubscriberProductAgreementModel";
import { SubscriberProductPriceModel } from "./SubscriberProductPriceModel";

export class SubscriberProductModel {
    idProduct: string = "";
    dueDay: number = 0;
    billingEnabled: boolean = false;
    isActive: boolean = false;
    canceledAt: Date|string|null = null;
    product: ProductModel;
    seller: SellerModel;
    agreements: SubscriberProductAgreementModel[] = []
    price: SubscriberProductPriceModel = new SubscriberProductPriceModel()
    firstBilling: BillingModel = new BillingModel()
    secondBilling: BillingModel = new BillingModel()

    constructor(s?:Partial<SubscriberProductModel>) {
        Object.assign(this, s)

        this._parseProduct()
        this._parseSeller()
        this._parseAgreements()
        this._parseBillings()
        this._parsePrice()
    }

    hasFirstBilling():boolean {
        return !!this.firstBilling && !!this.firstBilling.createdAt
    }

    hasSecondBilling():boolean {
        return !!this.secondBilling && !!this.secondBilling.createdAt
    }

    hasBeenCanceled():boolean {
        return !!this.canceledAt
    }

    private _parseBillings():void {
        this.firstBilling = new BillingModel(this.firstBilling)
        this.secondBilling = new BillingModel(this.secondBilling)
    }

    private _parseProduct():void {
        this.product = new ProductModel(this.product)
    }

    private _parseSeller():void {
        this.seller = new SellerModel(this.seller)
    }

    private _parseAgreements():void {
        this.agreements = (this.agreements || []).map((ag) => new SubscriberProductAgreementModel(ag))
    }

    private _parsePrice():void {
        this.price = new SubscriberProductPriceModel(this.price)
    }
}

